import React from 'react';

const StarsIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.66797 15.8333C1.66797 14 3.16797 12.5 5.0013 12.5H8.33464C10.168 12.5 11.668 14 11.668 15.8333"
      stroke={props.color || '#000000'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.7512 5.00029C9.91787 6.16696 9.91787 8.00029 8.7512 9.08362C7.58453 10.167 5.7512 10.2503 4.66787 9.08362C3.58453 7.91696 3.5012 6.16696 4.58453 5.00029C5.66787 3.83362 7.58453 3.91696 8.7512 5.00029"
      stroke={props.color || '#000000'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3359 11.668H15.8359C17.2526 11.668 18.3359 12.7513 18.3359 14.168"
      stroke={props.color || '#000000'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.085 5.58594C16.9184 6.41927 16.9184 7.7526 16.085 8.5026C15.2517 9.25261 13.9184 9.33594 13.1684 8.5026C12.4184 7.66927 12.335 6.33594 13.1684 5.58594C13.9184 4.83594 15.2517 4.83594 16.085 5.58594"
      stroke={props.color || '#000000'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default StarsIcon;
